import ReactTable from 'react-table'
import 'react-table/react-table.css'
import React from 'react';
import * as selectors from "./selectors";
import {Saga} from "./actions";
import {connect} from "react-redux";
import ModalContainer from '../ui/modal/Modals';
import {INTERNAL_AMENDMENT_VIEW_PATH} from "../ajax/sdgOnlinePaths";

const Datagrid = ({
                    onExpandedChange, onResizedChange, onFetchData,
                    data, page, pageSize, pages, filtered, sorted, keyword, loading,
                    onPageChange, onPageSizeChange, onFilteredChange, onKeywordChange, onSortedChange
                  }) => {

  const columns = [
    {
      id: 'request_no',
      Header: 'Request No.',
      accessor: 'sourceAsMap.request_no',
      Filter: ({ filter, onChange }) =>   <input type="number" onChange={event => onChange(event.target.value)} value={filter? filter.value : ''} />
    },
    {
      id: 'requested_by',
      Header: 'Requester Name',
      accessor: 'sourceAsMap.requested_by'
    },
    {
      id: 'status.label',
      Header: 'Status',
      accessor: 'sourceAsMap.status.label'
    },
    {
      id: 'documents.name',
      Header: 'Affected Documents',
      accessor: 'sourceAsMap.documents',
      Cell: props => props.value.map(e => e.name).join(", ")
    },
    {
      id: 'documents.category',
      Header: 'Document Category',
      accessor: 'sourceAsMap.documents',
      Cell: props => props.value.map(e => e.category).join(", ")
    }];

  const onRowClick = (rowInfo) => {
    window.location = INTERNAL_AMENDMENT_VIEW_PATH + rowInfo.original.id;
  }

  return (<React.Fragment>


    <form onSubmit={e => {
      e.preventDefault();
    }}>
      <div className="field-group mb-3">
        <label htmlFor="keyword">Keyword</label>
        <input id="keyword" className="form-control" name="keyword" type="text" value={keyword}
               onChange={evt => onKeywordChange(evt.target.value)}/>
      </div>
    </form>

    <ReactTable
      manual
      filterable
      page={page}
      pages={pages}
      pageSize={pageSize}
      data={data}
      columns={columns}
      filtered={filtered}
      sorted={sorted}
      onSortedChange={onSortedChange}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
      onExpandedChange={onExpandedChange}
      onResizedChange={onResizedChange}
      onFilteredChange={onFilteredChange}
      onFetchData={onFetchData}
      loading={loading}
      className="-striped -highlight"
      getTrProps={(state, rowInfo) => ({
        onClick: () => {
          onRowClick(rowInfo);
        }
      })}
    >
    </ReactTable>
    <ModalContainer/>
  </React.Fragment>)

};


const mapStateToProps = state => {
  return {
    keyword: selectors.getKeyword(state),
    sorted: selectors.getSorted(state),
    page: selectors.getPage(state),
    pages: selectors.getPages(state),
    pageSize: selectors.getPageSize(state),
    expanded: selectors.getExpanded(state),
    resized: selectors.getResized(state),
    filtered: selectors.getFiltered(state),
    loading: selectors.getLoading(state),
    data: selectors.getData(state)
  }
};

const mapDispatchToProps = dispatch => ({
    onKeywordChange: keyword => {
      dispatch(Saga.tableStateChange({keyword}));
      dispatch(Saga.doFetchData())
    },
    onSortedChange: sorted => dispatch(Saga.tableStateChange({sorted})),
    onPageChange: page => dispatch(Saga.tableStateChange({page})),
    onPageSizeChange: (pageSize, page) => dispatch(Saga.tableStateChange({page, pageSize})),
    onExpandedChange: expanded => dispatch(Saga.tableStateChange({expanded})),
    onResizedChange: resized => dispatch(Saga.tableStateChange({resized})),
    onFilteredChange: filtered => dispatch(Saga.tableStateChange({'page': 0, filtered})),
    onFetchData: (state, instance) => dispatch(Saga.doFetchData())
  }
)

export default connect(mapStateToProps, mapDispatchToProps)(Datagrid);